// used for blocking a section of content while ajax is loading...
// <div class="loading-block">
//   <span><span class="fa fa-loading fa-spinner fa-spin"></span> Loading...</span>
//   <div class="loading-block-bg"></div>
// </div>

bq.loadBlock = function(element, options) {
  this.options   = options;
  this.$element  = $(element);
  this.active    = false;
  this.callCount = 0;
};

bq.loadBlock.DEFAULTS = {
  triggerStart: '',
  triggerEnd: '',
  message: bq.messages.global.loading
};

bq.loadBlock.prototype = {
  init: function() {
    bq.debug.log("Load Block : init()", this.$element);

    if(this.options.triggerStart.length <= 0 || this.options.triggerEnd.length <= 0 ) { //if no triggers found, just exit with error
      bq.debug.error("Load Block : No data-trigger-* found", this);
      return;
    }

    //set up event catching
    this.$element.on(this.options.triggerStart, {thiz: this}, this.loadStart);
    this.$element.on(this.options.triggerEnd, {thiz: this}, this.loadEnd);

  },

  loadStart: function(e) {
    var $this = e.data.thiz;
    if($this.active) { $this.callCount++; return; } //already running, no reason to do anything
    $this.active = true;
    $this.callCount = 1;

    bq.debug.log("Load Block : loadStart");

    //Rerouting to new view handler loading mask (view-handler.js)
    $('body').trigger('bq.viewhandler.start');

  },

  loadEnd: function(e) {
    var $this = e.data.thiz;
    if(!$this.active) { return; } //already stopped, no reason to do anything
    if($this.callCount == 1) {
      $this.active = false;

      bq.debug.log("Load Block : loadEnd");
      //Rerouting to new view handler loading mask (view-handler.js)
      $('body').trigger('bq.viewhandler.stop');
    } else {
      $this.callCount--;
    }
  }

};

// LOAD BLOCK PLUGIN DEFINITION
// =======================

var loadBlockold = $.fn.loadBlock;

$.fn.loadBlock = function (option, _relatedTarget) {
  return this.each(function () {
    var $this   = $(this);
    var data    = $this.data('bq.loadBlock');
    var options = $.extend({}, bq.loadBlock.DEFAULTS, $this.data(), typeof(option) === 'object' && option);

    if (!data) { $this.data('bq.loadBlock', (data = new bq.loadBlock(this, options))); }
    data.init();
  });
};

$.fn.loadBlock.Constructor = bq.loadBlock;

// LOAD BLOCK NO CONFLICT
// =================

$.fn.loadBlock.noConflict = function () {
  $.fn.loadBlock = loadBlockold;
  return this;
};

// LOAD BLOCK DATA-API
// ==============

bq.loadBlockInit = function() {
  $('[data-bq="load-block"]').each(function () {
    var el = $(this);
    if(el.data('bq.loadBlock')) { return; }
    el.loadBlock(el.data());
  });
};

bq.init.push(bq.loadBlockInit);
